import api from "../api";

export const propertiesMonthlyInspectionsService = {
  // Get all properties with monthly inspections data
  getProperties: async (params = {}) => {
    try {
      const response = await api.post(
        "/properties/monthly-inspections",
        params
      );
      return response;
    } catch (error) {
      console.error("Error fetching properties monthly inspections:", error);
      throw error;
    }
  },

  // Get properties overview statistics
  getPropertiesOverview: async () => {
    try {
      const response = await api.get(
        "/properties/monthly-inspections/overview"
      );
      return response;
    } catch (error) {
      console.error("Error fetching properties overview:", error);
      throw error;
    }
  },

  // Get account managers for filter
  getAccountManagers: async () => {
    try {
      const response = await api.get("/account-managers");
      return response;
    } catch (error) {
      console.error("Error fetching account managers:", error);
      throw error;
    }
  },

  // Get inspection routes for filter
  getInspectionRoutes: async () => {
    try {
      const response = await api.get("/inspection-routes");
      return response;
    } catch (error) {
      console.error("Error fetching inspection routes:", error);
      throw error;
    }
  },

  // Search clients (for typeahead)
  searchClients: async (query) => {
    try {
      const response = await api.get(`/clients/ajax/${query}`);
      return response;
    } catch (error) {
      console.error("Error searching clients:", error);
      throw error;
    }
  },

  // Search properties (for typeahead)
  searchProperties: async (query) => {
    try {
      const response = await api.get(`/properties/ajax/${query}`);
      return response;
    } catch (error) {
      console.error("Error searching properties:", error);
      throw error;
    }
  },

  // Get monthly inspection status for a specific property
  getPropertyMonthlyInspectionStatus: async (propertyId) => {
    try {
      const response = await api.get(
        `/properties/${propertyId}/monthly-inspections/status`
      );
      return response;
    } catch (error) {
      console.error(
        "Error fetching property monthly inspection status:",
        error
      );
      throw error;
    }
  },

  // Get monthly inspections for a specific property
  getPropertyMonthlyInspections: async (propertyId) => {
    try {
      const response = await api.get(
        `/properties/${propertyId}/monthly-inspections`
      );
      return response;
    } catch (error) {
      console.error("Error fetching property monthly inspections:", error);
      throw error;
    }
  },

  // Delete property and all related records
  deleteProperty: async (propertyId) => {
    try {
      const response = await api.delete(`/properties/${propertyId}/destroy`);
      return response;
    } catch (error) {
      console.error("Error deleting property:", error);
      throw error;
    }
  },

  // Update monthly inspection ignore status
  updateMonthlyInspectionIgnore: async (propertyId, year, month, ignored) => {
    try {
      const response = await api.post(
        "/properties/monthly-inspections/ignore",
        {
          property_id: propertyId,
          year: year,
          month: month,
          ignored: ignored,
        }
      );
      return response;
    } catch (error) {
      console.error("Error updating monthly inspection ignore status:", error);
      throw error;
    }
  },

  // Export properties monthly inspections as CSV
  exportCSV: async (params = {}) => {
    try {
      const response = await api.post(
        "/properties/monthly-inspections/export/csv",
        params,
        {
          responseType: "blob",
        }
      );
      return response;
    } catch (error) {
      console.error("Error exporting CSV:", error);
      throw error;
    }
  },

  // Export properties monthly inspections as PDF
  exportPDF: async (params = {}) => {
    try {
      const response = await api.post(
        "/properties/monthly-inspections/export/pdf",
        params,
        {
          responseType: "blob",
        }
      );
      return response;
    } catch (error) {
      console.error("Error exporting PDF:", error);
      throw error;
    }
  },

  // Get monthly inspection statistics
  getMonthlyInspectionStatistics: async () => {
    try {
      const response = await api.get(
        "/properties/monthly-inspections/statistics"
      );
      return response;
    } catch (error) {
      console.error("Error fetching monthly inspection statistics:", error);
      throw error;
    }
  },

  // Get properties by status
  getPropertiesByStatus: async (statusId) => {
    try {
      const response = await api.post("/properties/monthly-inspections", {
        status_id: statusId,
      });
      return response;
    } catch (error) {
      console.error("Error fetching properties by status:", error);
      throw error;
    }
  },
};
